import React, { useState, useEffect, useCallback } from 'react';
import Sidebar from './dashboard/Sidebar';
import NotificacionesBell from './NotificacionesBell';
import UserMenu from './UserMenu';

const MOBILE_BREAKPOINT = 768;

export default function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth >= MOBILE_BREAKPOINT);
  const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_BREAKPOINT);

  const handleResize = useCallback(() => {
    const mobile = window.innerWidth < MOBILE_BREAKPOINT;
    setIsMobile(mobile);
    if (!mobile) setSidebarOpen(true);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar isOpen={sidebarOpen} onToggle={setSidebarOpen} />

      {/* Topbar fixed — mismo contexto de posicionamiento que el sidebar (fixed),
          garantiza que la línea divisoria inferior quede perfectamente alineada */}
      <div style={{
        position: 'fixed',
        top: 0,
        left: isMobile ? 0 : 240,
        right: 0,
        height: 60,
        zIndex: 200,
        background: '#101728',
        borderBottom: '1px solid #1e2a44',
        display: 'flex',
        alignItems: 'center',
        justifyContent: isMobile ? 'flex-start' : 'flex-end',
        padding: '0 24px',
        gap: 12,
        boxSizing: 'border-box',
      }}>
        {isMobile && (
          <>
            <button onClick={() => setSidebarOpen(true)} style={{
              background: 'none', border: 'none', color: '#fff',
              fontSize: 24, cursor: 'pointer', padding: 0, lineHeight: 1,
            }}>☰</button>
            <img src="/logo-menu-sidebar-ai-leth-blanco.png" alt="Aileth"
              style={{ height: 28 }}
              onError={(e) => { e.target.onerror = null; e.target.src = '/logo-aileth-navar.png'; }}
            />
          </>
        )}
        <div style={{ marginLeft: isMobile ? 'auto' : 0, display: 'flex', alignItems: 'center', gap: 8 }}>
          <NotificacionesBell />
          <UserMenu />
        </div>
      </div>

      {/* Área de contenido: margen izquierdo por el sidebar, margen superior por el topbar */}
      <div style={{
        flex: 1,
        marginLeft: isMobile ? 0 : 240,
        marginTop: 60,
        backgroundColor: '#f5f6fa',
        minHeight: 'calc(100vh - 60px)',
      }}>
        <div style={{ padding: isMobile ? '16px' : '20px' }}>
          {children}
        </div>
      </div>
    </div>
  );
}
